import { ApiUnauthorizedError, ApiTimeoutError, ApiNetworkError } from '../services/claimsApi'

// The ad-hoc contact proc rejects a repeated name+email pair (Msg 105). The form's own
// pre-check and the save hook both use this wording, so the user reads one message
// wherever the duplicate was caught.
export const DUPLICATE_ADHOC_CONTACT_MESSAGE = 'This name and email are already on the claim.'

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiUnauthorizedError) return 'Please sign in to continue.'
  if (err instanceof ApiTimeoutError) return (err as Error).message
  if (err instanceof ApiNetworkError) return (err as Error).message
  return fallback
}

const NETWORK_ERROR_PATTERNS = [/aborted/i, /internal error/i, /network/i, /fetch/i, /failed to fetch/i]

export function getAttachmentActionErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiUnauthorizedError) return 'Please sign in to continue.'
  if (err instanceof ApiTimeoutError || err instanceof ApiNetworkError) return 'Network error. Please try again.'
  if (err instanceof Error && NETWORK_ERROR_PATTERNS.some((p) => p.test(err.message))) {
    return 'Network error. Please try again.'
  }
  return fallback
}
